// extracted by mini-css-extract-plugin
module.exports = {"content":"LifeCycleCard_content__MEj20"};